import { Const } from '~/constants/Const.constant';
import { controlledDevices, subtype } from '~/helpers/fields-description';
import { Endpoint } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { NAModule } from '~/models/modules/NAModule.model';
export class WirelessSwitch extends NAModule {
    isWired = false;
    hasOperationReset = false;
    endpoints: Endpoint[] = [];
    battery_levels = {
        full: Const.NABatteryLevelMagellan.NLT_LEVEL_0,
        high: Const.NABatteryLevelMagellan.NLT_LEVEL_1,
        medium: Const.NABatteryLevelMagellan.NLT_LEVEL_2,
        low: Const.NABatteryLevelMagellan.NLT_LEVEL_3,
    };

    get fieldControlledDevices(): FieldObject | undefined {
        return controlledDevices(this.controlledDevice(0));
    }

    get controlledDevice() {
        return (button: number) => {
            return (typeof this.endpoints !== 'undefined' && typeof this.endpoints[button] !== 'undefined') ?
                this.endpoints[button].bindings : undefined;
        };
    }

    get fieldSubtype(): FieldObject | undefined {
        return subtype(this.subtype);
    }
}
